import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "main-button-wrap"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'MainButton',
  props: {
    disabled: {
      type: Boolean
    },
    size: null
  },
  emits: ['click'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const onClick = () => {
      !(props !== null && props !== void 0 && props.disabled) && emits('click', null);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["main-button", {
          disabled: props === null || props === void 0 ? void 0 : props.disabled,
          'main-button__small': (props === null || props === void 0 ? void 0 : props.size) === 'small',
          'main-button__large': (props === null || props === void 0 ? void 0 : props.size) === 'large'
        }]),
        onClick: onClick
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", null, [_renderSlot(_ctx.$slots, "default")])])], 2);
    };
  }
});